export const PATH = {
    ASK_INTENTICO: '/ask',
    // Auth Pages
    LOGIN: '/login',
    AUTH_CALLBACK: '/auth/callback',
    FORGOT_PASSWORD: '/forgot-password',
    ACTIVATE_ACCOUNT: '/activate-account',
    RESET_PASSWORD: '/reset-password',
    SIGNUP: '/signup',
    SIGNUP_SUCCESS: '/signup/success',
    SIGNUP_CANCEL: '/signup/cancel',
    SUBSCRIPTION_INACTIVE: '/subscription-inactive',

    // Error Pages
    ACCESS_DENIED: '/access-denied',
    NOT_FOUND: '/not-found',
    
    // Account Pages
    ALL_ACCOUNTS: "/all-accounts",
    ACCOUNT_DETAILS: '/account/:id',

    // Industry Insight Pages
    INDUSTRY_INSIGHTS: "/insights",

    // Static Pages
    LANDING: '/',
    PRICING: '/pricing',
    SECURITY: '/security',
    HELP: '/help',
    CONTACT: '/contact',
    DEMO: '/demo',
    INTEGRATIONS: '/integrations',
    HUBSPOT_INTEGRATION: '/integrations/hubspot',
    SALESFORCE_INTEGRATION: '/integrations/salesforce',
    SLACK_INTEGRATION: '/integrations/slack',
    SLACK_SUPPORT: '/integrations/slack/support',
    TEAMS_INTEGRATION: '/integrations/microsoft-teams',
    TEAMS_SUPPORT: '/integrations/microsoft-teams/support',

    // Sales Home
    Sales_Home: '/sales-home',

    // Settings
    SETTINGS: '/settings',
    CRM_OAUTH_CALLBACK: '/settings/crm/oauth/callback',
    CRM_MATCH_REVIEWS: '/crm/reviews',

    // Admin
    ADMIN_CREATE_CLIENT: '/admin/clients/new',
    ADMIN_CLIENT_READINESS: '/admin/clients/readiness',
    ADMIN_CLIENT_LIMITS: '/admin/clients/limits',
    ADMIN_COSTS: '/admin/costs',
    CREATE_CAMPAIGN: '/campaigns/new',

    // Assets
    MY_ASSETS: '/my-assets',

    // Activity
    ACTIVITY: '/activity',

    // Legal
    ADDENDUMS: '/legal/addendums',
    GUIDELINES: '/guidelines',
    ACCEPTABLE_USE_POLICY: '/legal/acceptable-use-policy',
    PRIVACY_POLICY: '/legal/privacy-policy',
    TERMS_OF_SERVICE: '/legal/terms-of-service',
};
